<template>
  <div>
    <div
      v-if="fixed && hasPlaceholder"
      :style="{ height: placeholderHeight }"
      :class="[fixed && 'nav-placeholder']"
    ></div>
    <div
      :class="['nav-bar-wrap', fixed && 'nav-bar-fixed']"
      :style="{
        'background-color': updateBackground,
      }"
    >
      <BasicTopSafeArea />
      <div
        class="nav-bar-box"
        :style="{
          height: systemStoreData.info.navBarH + 'px',
        }"
      >
        <slot name="left">
          <span class="placeholder"></span>
        </slot>
        <slot name="center"></slot>
        <slot name="right">
          <span class="placeholder"></span>
        </slot>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import useSystemStore from '~~/store/system'

const systemStoreData = useSystemStore()
const props = defineProps({
  fixed: {
    type: Boolean,
    default: () => false,
  },
  immersion: {
    type: Boolean,
    default: () => false,
  },
  opacityRatio: {
    type: Number,
    default: () => 0,
  },
  hasPlaceholder: {
    type: Boolean,
    default: true,
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
})

const placeholderHeight = computed(() => {
  return `${systemStoreData.info.safeTop + systemStoreData.info.navBarH}px`
})

const updateBackground = computed(() => {
  if (props.backgroundColor) {
    return props.backgroundColor
  }
  return props.fixed
    ? `rgba(255, 255, 255, ${props.immersion ? props.opacityRatio : 1})`
    : 'initial'
})
</script>
<style lang="less" scoped>
.nav-placeholder {
  width: 100%;
  height: 44px;
  box-sizing: content-box;
}
.nav-bar-wrap {
  width: 100%;
  box-sizing: content-box;
  background: transparent;
  .nav-bar-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 16px;
  }
}
.nav-bar-fixed {
  position: fixed;
  top: 0;
  z-index: 2000;
}
.placeholder {
  width: 20px;
  height: 10px;
}
</style>
